

// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";

// // Register necessary components for chart
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const PortfolioChart = ({
//   timePeriod,
//   NavUrl,
//   NavAPIKey,
//   investmentData,
//   navHistory,
// }) => {
//   const areaChartRef = useRef(null);
//   const areaChartInstance = useRef(null);


// const calculatePortfolioGrowth = (investmentData, navHistory) => {
//   if (!Array.isArray(navHistory) || navHistory.length === 0) return [];

//   let totalQuantity = 0;
//   let totalInvestmentValue = 0;

//   // Initialize total quantity and investment from investmentData
//   investmentData.forEach((investment) => {
//     totalQuantity += parseFloat(investment.nav_quantity || 0);
//     totalInvestmentValue += parseFloat(investment.nav_quantity || 0) * parseFloat(investment.nav_price || 0);
//   });

//   // Map over navHistory to calculate cumulative values
//   return navHistory.map((entry) => {
//     const date = entry.date;
//     const navPrice = parseFloat(entry.nav_price || 0);

//     // Update totals with each NAV history entry
//     totalQuantity += parseFloat(entry.nav_quantity || 0);
//     totalInvestmentValue += parseFloat(entry.nav_quantity || 0) * navPrice;

//     const portfolioValue = totalQuantity * navPrice;

//     return {
//       date,
//       currentValue: portfolioValue,
//     };
//   });
// };
  
    
// const updateCharts = async (selectedRange) => {
//     try {
//       const response = await axios.get(`${NavUrl}/nav-chart/?range=${selectedRange}`, {
//         headers: { authorization: `${NavAPIKey}` },
//       });
  
//       const processedNavHistory = response.data.data.map((nav) => ({
//         date: !isNaN(Date.parse(nav.nav_date || nav.date)) ? nav.nav_date || nav.date : null,
//         nav: parseFloat(nav.current_nav || nav.nav),
//       }));
  
//       const filteredNavHistory = processedNavHistory.filter((nav) => nav.date);
  
//       if (filteredNavHistory.length > 0) {
//         const portfolioGrowth = calculatePortfolioGrowth(navHistory, investmentData);
  
//         const labels = portfolioGrowth
//           .map((item) => {
//             const date = new Date(item.date);
//             return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
//               .toString()
//               .padStart(2, "0")}/${date.getFullYear()}`;
//           })
//           .reverse();
  
//         const currentValues = portfolioGrowth.map((item) => item.currentValue);
  
//         if (areaChartInstance.current) {
//           areaChartInstance.current.data.labels = labels;
//           areaChartInstance.current.data.datasets[1].data = currentValues;
//           areaChartInstance.current.update();
//         } else {
//           const ctx = areaChartRef.current.getContext("2d");
//           areaChartInstance.current = new ChartJS(ctx, {
//             type: "line",
//             data: {
//                 labels: labels,
//               datasets: [
//                   {
//                   label: "Current Value",
//                   data: currentValues,
//                   borderColor: "#00acc1",
//                   borderWidth: 2,
//                   pointRadius: 0,
//                 },
//               ],
//             },
//             options: {
//               responsive: true,
//               plugins: {
//                 tooltip: {
//                   enabled: true,
//                   mode: "index",
//                   intersect: false,
//                   callbacks: {
//                     label: (tooltipItem) => {
//                       const datasetLabel = tooltipItem.dataset.label || '';
//                       const value = tooltipItem.raw.toFixed(2);
//                       return `${datasetLabel}: ${value}`;
//                     },
//                   },
//                 },
//                 legend: { display: false },
//               },
//             },
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching NAV data:", error);
//     }
//   };
  

//   useEffect(() => {
//     if (investmentData.length > 0 && areaChartRef.current) {
//       updateCharts(timePeriod);
//     }
//   }, [timePeriod, investmentData, navHistory]);

//   return (
//     <div>
//       <canvas ref={areaChartRef}></canvas>
//     </div>
//   );
// };

// export default PortfolioChart;

import React, { useRef, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const PortfolioChart = ({ timePeriod, investmentData, navHistory }) => {
  const areaChartRef = useRef(null);
  const areaChartInstance = useRef(null);


  const calculatePortfolioGrowth = (investmentData) => {
    let totalQuantity = 0;
    let totalInvestmentValue = 0;
    let growthData = [];
    
    // Iterate through the investmentData to calculate the total value at each step
    investmentData.forEach((investment, index) => {
      // Update total quantity and total investment value
      totalQuantity += parseFloat(investment.nav_quantity || 0);
      totalInvestmentValue += parseFloat(investment.nav_quantity || 0) * parseFloat(investment.nav_price || 0);
    
      
      // Push the portfolio value and corresponding date into the growthData array
      growthData.push({
        date: investment.nav_date,
        currentValue: totalInvestmentValue,
      });
    });
  
    return growthData;
  };
  
  const updateCharts = () => {
    const portfolioGrowth = calculatePortfolioGrowth(investmentData);
  
    const labels = portfolioGrowth.map((item) => {
      const date = new Date(item.date);
      return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${date.getFullYear()}`;
    });
  
    // Extract the portfolio values
    const currentValues = portfolioGrowth.map((item) => item.currentValue);
  
    if (areaChartInstance.current) {
      areaChartInstance.current.data.labels = labels;
      areaChartInstance.current.data.datasets[0].data = currentValues;
      areaChartInstance.current.update();
    } else {
      const ctx = areaChartRef.current.getContext("2d");
      areaChartInstance.current = new ChartJS(ctx, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Value",
              data: currentValues,
              borderColor: "#00acc1",
              borderWidth: 2,
              pointRadius: 0,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              enabled: true,
              mode: "index",
              intersect: false,
              callbacks: {
                label: (tooltipItem) => {
                  const datasetLabel = tooltipItem.dataset.label || "";
                  const value = tooltipItem.raw.toFixed(2);
                  return `${datasetLabel}: $${value}`;
                },
              },
            },
            legend: { display: false },
          },
        },
      });
    }
  };
  

  useEffect(() => {
    updateCharts();
  }, [timePeriod, investmentData, navHistory]);

  return <canvas ref={areaChartRef}></canvas>;
};

export default PortfolioChart;
